//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CurrencyFormatInfo } from './CurrencyFormatInfo';
import { NumberFormatInfo } from './NumberFormatInfo';
import { PercentFormatInfo } from './PercentFormatInfo';
import { DayOfWeekEnum, DistanceUnit } from './Enums';

export class LocalizationInfo extends ItemBase {
    CurrencyFormatInfo: CurrencyFormatInfo | null = null;
    NumberFormatInfo: NumberFormatInfo | null = null;
    PercentFormatInfo: PercentFormatInfo | null = null;
    ShortDatePattern: string | null = null;
    LongDatePattern: string | null = null;
    ShortTimePattern: string | null = null;
    LongTimePattern: string | null = null;
    YearMonthPattern: string | null = null;
    MonthDayPattern: string | null = null;
    FirstDayOfWeek: DayOfWeekEnum = DayOfWeekEnum.Sunday;
    DistanceUnit: DistanceUnit = DistanceUnit.Miles;
    Is12Hour: boolean = false;
    RightToLeft: boolean = false;
    AMDesignator: string | null = null;
    PMDesignator: string | null = null;
    DayNames: string[] = [];
    AbbreviatedDayNames: string[] = [];
    MonthNames: string[] = [];
    MonthGenitiveNames: string[] = [];
    AbbreviatedMonthNames: string[] = [];
    AbbreviatedMonthGenitiveNames: string[] = [];
    MaxCalendarDate: string = "1970-01-01T00:00:00";

    constructor(initializer?: Partial<LocalizationInfo>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "LocalizationInfo";
}
